/**
 * Test IDs for QA automation.
 */
export const testIds = {
  customerOrdersListCreateOrder: "customer-orders-list-create-order",
  customerOrdersListInProgressNavigation: "customer-orders-list-in-progress-navigation",
  customerOrdersListInProgressView: "customer-orders-list-in-progress-view",
  customerOrdersListCompleted: "customer-orders-list-completed",
} as const;
